import { Button, ButtonProps } from '@superdispatch/ui-lab';
import { PermissionAction } from './PermissionAction';
import { PermissionDTO } from '../PermissionDTO';
import { PermissionIcon } from './PermissionIcon';
import { usePermissionAccess } from '../data/usePermissionAccess';

interface PermissionButtonProps<
  T extends keyof PermissionDTO,
> extends ButtonProps {
  name: T;
  permission: keyof NonNullable<PermissionDTO[T]>;
  children: React.ReactNode;
}

export function PermissionButton<T extends keyof PermissionDTO>({
  name,
  permission,
  children,
  ...buttonProps
}: PermissionButtonProps<T>) {
  const hasNoAccess = usePermissionAccess({ name, permission });
  return (
    <PermissionAction name={name} permission={permission}>
      <Button
        {...buttonProps}
        startIcon={
          hasNoAccess ? (
            <PermissionIcon name={name} permission={permission}>
              <div>{buttonProps.startIcon}</div>
            </PermissionIcon>
          ) : (
            buttonProps.startIcon
          )
        }
      >
        {children}
      </Button>
    </PermissionAction>
  );
}
